import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ProcessRail from './components/ProcessRail';
import Benefits from './components/Benefits';
import AboutBanner from './components/AboutBanner';
import GalleryCarousel from './components/GalleryCarousel';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
          <AboutBanner />
        <Services />
        <ProcessRail />
          <GalleryCarousel />
        <Pricing />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
